<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :isHdLeftAttached="true">
    <template v-slot>
      <div class="dialog type-banner">
        <header class="dialog-header">
          <h2 class="dialog-title" hidden>배너 팝업</h2>
          <button type="button" class="dialog-close" @click="btnCmd('close')">
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <div class="c-banner-wrap">
              <commonPopSwiper
                :type="data.biz1.type"
                :data="data.biz1.list"
                :options="data.biz1.options"
              />
            </div>
          </div>
        </div>

        <div class="dialog-footer">
          <div class="cookie-today" @click="btnCmd('todayHide')">
            <div class="c-checkbox type-small">
              <input
                type="checkbox"
                id="cookie-hide-today"
                name="cookie-hide-today"
                v-model="data.biz1.isHidden"
              />
              <label for="cookie-hide-today">
                <span class="sr-only">오늘 하루 보지 않기 체크</span>
              </label>
            </div>
            <button type="button" class="btn-today">오늘 하루 보지 않기</button>
          </div>
        </div>
      </div>
      <div class="dimmed only-mo"></div>
    </template>
  </AbstractPop>
</template>
<script setup name="commonPop">
import { onMounted, reactive } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import commonPopSwiper from "@/components/common/swiper/commonPopSwiper.vue";

import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil";

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {},
  codes: {},
  popup: {},
  biz1: {
    type: "",
    list: [], // 목록
    options: {},
    page: 0, // 현재 페이지
    limit: 5, // 목록 조회 행수
    isHidden: false,
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await pageInitData();
  searchCmd("biz1#search"); // biz1 데이타 조회
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: commonPop.pageInitData] `);
    return false;
  }
}

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", parms = {}) {
  if (cmd === "biz1#search") {
    data.biz1.loading = true;
    const { isMobile } = cmUtil.useDeviceType();
    let parm = {
      deviceType: isMobile.value ? "M" : "P",
      start: 0,
      limit: 4,
    };
    const res = await cmApi.selectCommonPopupList(parm);
    data.biz1.list = res.data;
  } else {
    alert(`[개발확인] searchCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "close") {
    cmApi.closeCommonPop();
  } else if (cmd === "todayHide") {
    data.biz1.isHidden = true;
    cmApi.closeCommonPop("todayHide");
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
